<template>
  <sModal
    v-model="showModalInfo"
    :mask-closable="false"
    :title="$t('AIRequirements.Requirements')">
    <div v-if="requirement">
      <div
        key="indicators"
        class="flex gap-5 pb-4 ori-sticky-header">
        <OfferRequirementIndicators
          class="my-auto flex gap-5 flex gap-5"
          :filter-state.sync="filterState"
          is-clickable
          :requirements="requirement.requirements"/>
        <span
          ref="rate"
          class="offer-requirements-info_rate">{{ requirement.complianceRate }}%</span>
      </div>
      <transition-group
        key="transition-requirements"
        class="offer-requirements-info_items"
        name="s-zoom-in-top"
        tag="div">
        <div
          v-for="(requirementItem, requirementIndex) in filteredRequirements"
          :key="`${requirementIndex}-${requirementItem.requirement}`"
          :class="`offer-requirements-info_item-state offer-requirements-info_item-state-${requirementItem.assessment}`">
          {{ requirementItem.requirement }}
        </div>
      </transition-group>
    </div>
    <div
      key="footer"
      slot="footer">
      <sButton
        type="text"
        @click="showModalInfo = null">
        {{ $t('Common.Close') }}
      </sButton>
    </div>
  </sModal>
</template>
<script>
import OfferRequirementIndicators from 'components/tenders/tender page/tender tabs/OfferRequirementIndicators.vue'

export default {
  name: 'OfferRequirementsInfo',
  data() {
    return {
      filterState: []
    }
  },
  computed: {
    filteredRequirements() {
      if (!this.requirement?.requirements?.length || !this.filterState.length) {
        return this.requirement?.requirements ?? []
      }
      const state = []
      if (this.filterState.includes('success')) {
        state.push('COMPLIES')
      }
      if (this.filterState.includes('warning')) {
        state.push('PARTIAL', 'NOT_DETERMINED')
      }
      if (this.filterState.includes('error')) {
        state.push('NO', 'CRITICAL_NO')
      }
      return this.requirement.requirements.filter(r => state.includes(r.assessment))
    },
    color() {
      if (!this.requirement) {
        return 'var(--color-secondary)'
      }
      if (this.requirement?.isBest) {
        return 'var(--v-secondary__green_approved-base)'
      }
      if (this.requirement?.complianceRate <= 20) {
        return 'var(--color-error)'
      } else {
        return 'var(--color-warning)'
      }
    },
    showModalInfo: {
      get() {
        return !!this.requirement
      },
      set(newValue) {
        if (!newValue) {
          this.$emit('update:requirement', null)
        }
      }
    },
  },
  watch: {
    color: {
      immediate: true,
      handler(val) {
        this.$nextTick(() => {
          if (this.$refs?.rate) { this.$refs?.rate.style.setProperty('--backgroundColor', val) }
        })
      }
    }
  },
  components: {
    OfferRequirementIndicators,
  },
  props: {
    requirement: {
      type: Object,
    }
  },
}
</script>
<style scoped lang="scss">
.ori-sticky-header {
  position: sticky;
  top: -20px;
  background: var(--v-main__light_green-base);
}
.offer-requirements-info {
  &_rate {
    font-weight: 500;
    background-color: color-mix(in srgb, var(--backgroundColor) 80%, transparent);
    padding: 1px 6px;
    border-radius: 4px;
  }
  &_items {
    overflow: auto;
    display: grid;
    gap: 1px;
  }
  &_item-state {
    padding: 4px 8px;
    &-COMPLIES {
      background-color: color-mix(in srgb, var(--v-secondary__green_approved-base) 10%, transparent);
      color: var(--text-color);
    }
    &-PARTIAL, &-NOT_DETERMINED {
      background-color: color-mix(in srgb, var(--color-warning) 10%, transparent);
      color: var(--text-color);
    }
    &-NO, &-CRITICAL_NO {
      background-color: color-mix(in srgb, var(--color-error) 10%, transparent);
      color: var(--text-color);
    }
  }
}
</style>
